import { Grid, minmax, repeat } from '@adobe/react-spectrum';
import React from 'react';

import { CloudAppCard, ErrorBoundary } from '@exchange-frontends/components';
import { useAnalyticsPageLoad, useMediaQuery, useStaticData } from '@exchange-frontends/custom-hooks';
import { browsePage } from '@exchange-frontends/utils';

import { useAppIntegrations } from '../../utils/hooks';
import AppCardError from './AppCardError';

const AppIntegrations = () => {
  const twoColumns = useMediaQuery('(min-width: 1025px) and (max-width:1265px)');
  const { apps, isLoading, isError } = useAppIntegrations();
  const productsLocs = useStaticData('hostApps');

  useAnalyticsPageLoad(browsePage, apps?.filter(Boolean)?.length, apps?.length);

  return (
    <>
      <ErrorBoundary isError={isError}>
        {() => (
          <Grid
            gap="size-200"
            columns={repeat('auto-fill', minmax('min(100%, max(270px, 100%/3.5))', '1fr'))}
            justifyContent={twoColumns ? 'space-between' : null}
          >
            {apps?.map((app, idx) => (
              <ErrorBoundary
                key={app ? `${app.id}.${app.name}.${app.type}` : `aieb${idx}`}
                errorComponent={<AppCardError appId={app?.id.toString()} />}
              >
                <CloudAppCard
                  cloud="cc"
                  app={app}
                  loading={isLoading}
                  headerId="App Integration"
                  productsLocs={productsLocs}
                  shouldShowPrice={false}
                  shouldShowStars={false}
                  listingType={app?.type}
                />
              </ErrorBoundary>
            ))}
          </Grid>
        )}
      </ErrorBoundary>
    </>
  );
};

export default AppIntegrations;
